import { render, staticRenderFns } from "./DetailExemptList.vue?vue&type=template&id=546fe032"
import script from "./DetailExemptList.vue?vue&type=script&lang=js"
export * from "./DetailExemptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports